<label>
    <span [attr.data-automation-id]="dataAutomationId" class="switch">
        <ng-content select="[climbSwitch]"></ng-content>
        <span class="slider"></span>
    </span>
    <span><ng-content></ng-content></span>
</label>
<ng-content select="[climbSwitchHint], [climbSwitchError]"></ng-content>
